<form
  nz-form
  [formGroup]="selectForm"
  [nzLayout]="select.nzLayout ? select.nzLayout : 'vertical'"
>
  <nz-form-item>
    <nz-form-label nzFor="appSelect" *ngIf="select.label">
      {{ select.label }}
    </nz-form-label>
    <nz-form-control>
      <nz-select
        id="appSelect"
        class="select-dropdown"
        formControlName="selectedValue"
      >
        <nz-option
          *ngFor="let option of select.nzOptions"
          [nzLabel]="option.label"
          [nzValue]="option.value"
        >
        </nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>
</form>
